import currency_converter from "../assets/images/currency_converter.png";
import protfolio_v1 from "../assets/images/protfolio_v1.png";
import amazon_clone from "../assets/images/amazon_clone.png";
import calculator from "../assets/images/calculator.png";
import rock_paper_scissor from "../assets/images/rock_paper_scissor.png";
import travelers from "../assets/images/travelers.png";
export const projects = [
    {
        title: "Currency Converter",
        about: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, optio. Tempore perferendis suscipit ducimus repudiandae, ipsum ullam consequuntur aperiam accusantium laborum sapiente necessitatibus perspiciatis, error sint laboriosam, reiciendis illum ad.",
        img: currency_converter,
        demo: "...",
        code: "...",
        type: 'others'
    },
    {
        title: "Traveler",
        about: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, optio. Tempore perferendis suscipit ducimus repudiandae, ipsum ullam consequuntur aperiam accusantium laborum sapiente necessitatibus perspiciatis, error sint laboriosam, reiciendis illum ad.",
        img: travelers,
        demo: "...",
        code: "...",
        type: 'web'
    },
    {
        title: "Portfolio",
        about: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, optio. Tempore perferendis suscipit ducimus repudiandae, ipsum ullam consequuntur aperiam accusantium laborum sapiente necessitatibus perspiciatis, error sint laboriosam, reiciendis illum ad.",
        img: protfolio_v1,
        demo: "...",
        code: "...",
        type: 'web'
    },
    {
        title: "Amazon Clone",
        about: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, optio. Tempore perferendis suscipit ducimus repudiandae, ipsum ullam consequuntur aperiam accusantium laborum sapiente necessitatibus perspiciatis, error sint laboriosam, reiciendis illum ad.",
        img: amazon_clone,
        demo: "...",
        code: "...",
        type: 'web'
    },
    {
        title: "Calculator",
        about: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, optio. Tempore perferendis suscipit ducimus repudiandae, ipsum ullam consequuntur aperiam accusantium laborum sapiente necessitatibus perspiciatis, error sint laboriosam, reiciendis illum ad.",
        img: calculator,
        demo: "...",
        code: "...",
        type: 'others'
    },
    {
        title: "Rock Paper Scissors",
        about: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, optio. Tempore perferendis suscipit ducimus repudiandae, ipsum ullam consequuntur aperiam accusantium laborum sapiente necessitatibus perspiciatis, error sint laboriosam, reiciendis illum ad.",
        img: rock_paper_scissor,
        demo: "...",
        code: "...",
        type: 'game'
    }
]


